import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../services/auth/auth.service';
import { catchError } from 'rxjs/operators';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpInterceptorFn,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';

// Constants moved outside to avoid recreation on each request
const LOGOUT_THROTTLE_MS = 3000;
const AUTH_PREFIX = `${environment.AUTH_KEY} `;

// Shared state for throttling logout attempts
let lastLogoutTime = 0;

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  authService = inject(AuthService);
  platformId = inject(PLATFORM_ID);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!isPlatformBrowser(this.platformId)) {
      return next.handle(req);
    }
    if (!this.authService.isLoggedIn) {
      return next.handle(req).pipe(catchError(this.handleError));
    }

    const authToken = this.authService.state?.auth_token;
    if (!authToken) {
      return next.handle(req).pipe(catchError(this.handleError));
    }

    const cloned = req.clone({
      headers: req.headers.set('Authorization', AUTH_PREFIX + authToken),
    });

    return next.handle(cloned).pipe(catchError(this.handleError));
  }
  private handleUnauthorized = (): void => {
    const now = Date.now();
    if (now - lastLogoutTime > LOGOUT_THROTTLE_MS) {
      lastLogoutTime = now;
      this.authService.logout().subscribe();
    }
  };
  private handleError = (error: HttpErrorResponse) => {
    if (error.status === HttpStatusCode.Unauthorized) {
      this.handleUnauthorized();
    }
    return throwError(() => error);
  };
}
